const parseJson = (value: unknown) => {
  if (typeof value !== 'string') return value

  try {
    return JSON.parse(value)
  } catch {
    return false
  }
}

/**
 * Normaliza as mensagens de erro devolvidas pela API.
 * `notifications` e `details` podem vir como array, string simples ou string JSON.
 */
export const extractNotifications = (error: any): string[] => {
  const { details, notifications, message } = error?.response?.data || {}
  const errors: string[] = []

  const detailList = typeof details === 'string' ? parseJson(details)?.notifications || [details] : details
  if (Array.isArray(detailList)) errors.push(...detailList)

  const notificationList = typeof notifications === 'string' ? parseJson(notifications) || [notifications] : notifications
  if (Array.isArray(notificationList)) errors.push(...notificationList)

  if (errors.length === 0 && typeof message === 'string' && message.trim().length > 0) errors.push(message)

  return [...new Set(errors.filter((item) => typeof item === 'string' && item.trim().length > 0))]
}
